import { defaultValue, IProject } from '../../models/project.model';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_PROJECT,
  CREATE_PROJECT,
  FETCH_PROJECT,
  FETCH_PROJECT_LIST,
  UPDATE_PROJECT,
  FETCH_PROJECT_DETAIL,
  SUBMIT_FOR_APPROVAL_PROJECT,
  SUBMIT_FOR_UNLOCK_APPROVED_PROJECT,
} from './project.actions';
import { ProjectState } from './project.types';

const initialState: ProjectState = {
  errorMessage: '',
  item: defaultValue,
  items: [] as ReadonlyArray<IProject>,
  loading: false,
  totalItems: 0,
  view: defaultValue,
};

const reducer = (state: ProjectState = initialState, action: AppAction): ProjectState => {
  switch (action.type) {
    case REQUEST(FETCH_PROJECT_DETAIL):
    case REQUEST(FETCH_PROJECT_LIST):
    case REQUEST(CREATE_PROJECT):
    case REQUEST(FETCH_PROJECT):
    case REQUEST(UPDATE_PROJECT):
    case REQUEST(SUBMIT_FOR_APPROVAL_PROJECT):
    case REQUEST(SUBMIT_FOR_UNLOCK_APPROVED_PROJECT):
      return { ...state, loading: true };
    case SUCCESS(FETCH_PROJECT_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_PROJECT_DETAIL):
    case FAILURE(FETCH_PROJECT_LIST):
    case FAILURE(CREATE_PROJECT):
    case FAILURE(FETCH_PROJECT):
    case FAILURE(UPDATE_PROJECT):
    case FAILURE(SUBMIT_FOR_APPROVAL_PROJECT):
    case FAILURE(SUBMIT_FOR_UNLOCK_APPROVED_PROJECT):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(CREATE_PROJECT):
    case SUCCESS(FETCH_PROJECT):
    case SUCCESS(UPDATE_PROJECT):
    case SUCCESS(SUBMIT_FOR_APPROVAL_PROJECT):
    case SUCCESS(SUBMIT_FOR_UNLOCK_APPROVED_PROJECT):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_PROJECT:
      return {
        ...state,
        ...initialState,
      };
    case SUCCESS(FETCH_PROJECT_DETAIL):
      return { ...state, loading: false, view: action.payload.data };
    default:
      return state;
  }
};

export default reducer;
